export const CREATE_QUESTIONAIRE_CATEGORY = "CREATE_QUESTIONAIRE_CATEGORY"
export const CREATE_QUESTIONAIRE_CATEGORY_SUCCESSFUL =
  "CREATE_QUESTIONAIRE_CATEGORY_SUCCESSFUL"
export const CREATE_QUESTIONAIRE_CATEGORY_FAILED =
  "CREATE_QUESTIONAIRE_CATEGORY_FAILED"
export const CREATE_QUESTIONAIRE_CATEGORY_RESET =
  "CREATE_QUESTIONAIRE_CATEGORY_RESET"
